import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "styled-components";
import { CreatePostModalContext } from "../..";
import { useContainerSize } from "../../../../../../../../hooks/useContainerSize";
import { FlexRow } from "../../../../../../../Common/Styles";
import {
  AddTopicContainer,
  Container,
  HeadingContainer,
  InputContainer,
  Wrapper,
} from "./style";

const MAX_TOPICS = 3;

const Topics = () => {
  const [value, setValue] = useState("");
  const [height, setHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(true);
  const { typography, Color } = useTheme();
  const containerRef = useRef<HTMLDivElement>(null);
  const size = useContainerSize(containerRef);
  const { topics, setTopics } = useContext(CreatePostModalContext);

  useEffect(() => {
    if (containerRef?.current) {
      setHeight((containerRef?.current as Element)?.scrollHeight ?? 0);
    }
  }, [size, isOpen, topics]);

  return (
    <Container $isShow={isOpen || topics.length === 0}>
      {topics.length > 0 && (
        <HeadingContainer>
          <Wrapper $gapInPx={12}>
            <Components.Text
              style={{ tokenStyle: typography.Body.S }}
              text={"Topics"}
              fontWeight="font-weight-medium"
              color={"#350373"}
            />
            <FlexRow>
              {topics.map((topic, index) => (
                <Components.Pill
                  key={index}
                  onClick={() =>
                    setTopics(topics.filter((_, i) => i !== index))
                  }
                  text={topic.trim()}
                  showCloseIcon={true}
                />
              ))}
            </FlexRow>
          </Wrapper>
          <Components.IconButton
            iconType={isOpen ? "ChevronUp" : "ChevronDown"}
            onClick={() => setIsOpen(!isOpen)}
            disabled={false}
            kind="Secondary"
            size="XS"
          />
        </HeadingContainer>
      )}
      <AddTopicContainer
        ref={containerRef}
        height={isOpen || topics.length === 0 ? height : 0}
      >
        <HeadingContainer>
          <Components.Text
            style={{ tokenStyle: typography.Heading.XXS }}
            text={"Add topics"}
            fontWeight="font-weight-semibold"
            lineHeight="line-height-50"
          />
          <Wrapper>
            {topics.length === MAX_TOPICS && (
              <Components.Text
                style={{ tokenStyle: typography.Body.XS }}
                text={`Maximum ${MAX_TOPICS} topics.`}
                fontWeight="font-weight-medium"
                lineHeight="line-height-25"
                color={Color.text["text-emphasize-negative"].value}
              />
            )}
            <Components.IconButton
              iconType="Info"
              IconButtonColor="#8B33FA"
              onClick={() => {}}
              disabled={false}
              kind="Secondary"
              size="XS"
            />
          </Wrapper>
        </HeadingContainer>
        <InputContainer>
          <Inputs.Input
            fieldName="topic"
            idPrefix="topic"
            isRequired={false}
            placeholder="Press enter to add a topic. Use “,” (comma) to add multiple topics at a time."
            size="Large"
            type="text"
            disabled={topics.length === MAX_TOPICS}
            value={value}
            onChangeHandler={(value) => {
              setValue(value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                const newTopics = [
                  ...topics,
                  ...value
                    .split(",")
                    .filter((item) => item.trim())
                    .slice(0, MAX_TOPICS - topics.length),
                ];
                setTopics(newTopics);
                setValue("");
                newTopics.length >= MAX_TOPICS && setIsOpen(false);
              }
            }}
          />
        </InputContainer>
      </AddTopicContainer>
    </Container>
  );
};

export default Topics;
